import { css } from '@emotion/react'
import { gemVar, ThemedColors, Timing, Transition } from '@opallabs/gem'

const rootSelector = 'lapidary-progress-wheel'
export const selectors = {
  root: rootSelector,
  ring: `${rootSelector}-ring`,
  progressStroke: `${rootSelector}-progress-stroke`,
}

export const ring = css({
  fill: 'transparent',
  stroke: gemVar(ThemedColors.StrokeSecondary1),
  strokeLinecap: 'round',
})

export const progressStroke = css({
  stroke: gemVar(ThemedColors.StrokeSecondary3),
  transform: 'rotate(-90deg)',
  transformOrigin: '50% 50%',
  ...Transition(['stroke-dashoffset'], { duration: Timing.Default }),
})
